var _defs, _style, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _path17, _path18, _path19, _path20, _path21, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _path22, _path23, _path24, _path25, _path26, _defs2, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _path27, _path28, _path29, _path30, _path31, _defs3, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _path32, _path33, _path34, _path35, _path36, _ellipse, _path37, _path38, _path39, _path40, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _path41, _path42, _path43, _path44, _path45, _g3, _rect, _path46, _g4, _rect2, _path47, _path48, _path49, _path50, _polygon49, _polygon50, _path51, _path52, _path53, _path54, _path55, _polygon51;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditeursprosCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "14.84 -11.415 1719.096 290.97",
    style: {
      enableBackground: "new 0 0 1920 421.1"
    },
    width: "1719.096px",
    height: "290.97px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:#FFC568;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:url(#SVGID_4_);}\r\n\t.st6{fill:url(#SVGID_5_);}\r\n\t.st7{fill:#B7C2C7;}\r\n\t.st8{fill:url(#SVGID_6_);}\r\n\t.st9{fill:url(#SVGID_7_);}\r\n\t.st10{fill:url(#SVGID_8_);}\r\n\t.st11{fill:url(#SVGID_9_);}\r\n\t.st12{fill:url(#SVGID_10_);}\r\n\t.st13{fill:url(#SVGID_11_);}\r\n\t.st14{fill:url(#SVGID_12_);}\r\n\t.st15{fill:url(#SVGID_13_);}\r\n\t.st16{fill:url(#SVGID_14_);}\r\n\t.st17{fill:url(#SVGID_15_);}\r\n\t.st18{fill:url(#SVGID_16_);}\r\n\t.st19{fill:url(#SVGID_17_);}\r\n\t.st20{fill:url(#SVGID_18_);}\r\n\t.st21{fill:url(#SVGID_19_);}\r\n\t.st22{fill:url(#SVGID_20_);}\r\n\t.st23{fill:url(#SVGID_21_);}\r\n\t.st24{fill:url(#SVGID_22_);}\r\n\t.st25{fill:url(#SVGID_23_);}\r\n\t.st26{fill:url(#SVGID_24_);}\r\n\t.st27{fill:url(#SVGID_25_);}\r\n\t.st28{fill:url(#SVGID_26_);}\r\n\t.st29{fill:url(#SVGID_27_);}\r\n\t.st30{fill:url(#SVGID_28_);}\r\n\t.st31{fill:url(#SVGID_29_);}\r\n\t.st32{fill:url(#SVGID_30_);}\r\n\t.st33{fill:url(#SVGID_31_);}\r\n\t.st34{fill:url(#SVGID_32_);}\r\n\t.st35{fill:url(#SVGID_33_);}\r\n\t.st36{fill:url(#SVGID_34_);}\r\n\t.st37{fill:url(#SVGID_35_);}\r\n\t.st38{fill:url(#SVGID_36_);}\r\n\t.st39{fill:url(#SVGID_37_);}\r\n\t.st40{fill:url(#SVGID_38_);}\r\n\t.st41{fill:url(#SVGID_39_);}\r\n\t.st42{fill:url(#SVGID_40_);}\r\n\t.st43{fill:#E9E9E9;}\r\n\t.st44{fill:url(#SVGID_41_);}\r\n\t.st45{fill:url(#SVGID_42_);}\r\n\t.st46{fill:url(#SVGID_43_);}\r\n\t.st47{fill:url(#SVGID_44_);}\r\n\t.st48{fill:url(#SVGID_45_);}\r\n\t.st49{fill:url(#SVGID_46_);}\r\n\t.st50{fill:url(#SVGID_47_);}\r\n\t.st51{fill:url(#SVGID_48_);}\r\n\t.st52{fill:url(#SVGID_49_);}\r\n\t.st53{fill:url(#SVGID_50_);}\r\n\t.st54{fill:url(#SVGID_51_);}\r\n\t.st55{fill:#FE7E66;}\r\n\t.st56{clip-path:url(#SVGID_53_);}\r\n\t.st57{fill:url(#SVGID_54_);}\r\n\t.st58{fill:url(#SVGID_55_);}\r\n\t.st59{fill:url(#SVGID_56_);}\r\n\t.st60{fill:url(#SVGID_57_);}\r\n\t.st61{fill:url(#SVGID_58_);}\r\n\t.st62{fill:url(#SVGID_59_);}\r\n\t.st63{fill:url(#SVGID_60_);}\r\n\t.st64{fill:#8994B5;}\r\n\t.st65{clip-path:url(#SVGID_62_);}\r\n\t.st66{fill:url(#SVGID_63_);}\r\n\t.st67{fill:url(#SVGID_64_);}\r\n\t.st68{fill:url(#SVGID_65_);}\r\n\t.st69{fill:url(#SVGID_66_);}\r\n\t.st70{fill:url(#SVGID_67_);}\r\n\t.st71{fill:url(#SVGID_68_);}\r\n\t.st72{fill:url(#SVGID_69_);}\r\n\t.st73{opacity:0.1;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st74{fill:#8994AD;}\r\n\t.st75{fill:url(#SVGID_70_);}\r\n\t.st76{fill:url(#SVGID_71_);}\r\n\t.st77{fill:url(#SVGID_72_);}\r\n\t.st78{fill:url(#SVGID_73_);}\r\n\t.st79{fill:url(#SVGID_74_);}\r\n\t.st80{fill:url(#SVGID_75_);}\r\n\t.st81{fill:url(#SVGID_76_);}\r\n\t.st82{fill:url(#SVGID_77_);}\r\n\t.st83{fill:url(#SVGID_78_);}\r\n\t.st84{fill:url(#SVGID_79_);}\r\n\t.st85{opacity:0.17;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st86{fill:#E4E4E4;}\r\n\t.st87{opacity:0.64;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st88{fill:url(#SVGID_80_);}\r\n\t.st89{fill:url(#SVGID_81_);}\r\n\t.st90{fill:url(#SVGID_82_);}\r\n\t.st91{fill:url(#SVGID_83_);}\r\n\t.st92{fill:url(#SVGID_84_);}\r\n\t.st93{fill:#EEEEF2;}\r\n\t.st94{fill:#F6F6F8;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4050.9758,
    y1: 481.3189,
    x2: 5981.2759,
    y2: 481.3189,
    gradientTransform: "matrix(-0.732383, 0, 0, -0.68165, 4500.54, 449.638)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    style: {
      stopColor: "#082150"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#1C3C70"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 1485.08 194.457 C 1319.57 307.613 982.28 257.388 808.834 186.794 C 588.425 97.088 396.988 79.027 261.105 137.958 C 109.114 188.245 19.572 -7.325 23.508 -11.136 C 26.192 -13.735 1717.82 -11.141 1717.82 -11.141 C 1718.7 -10.677 1602.72 114.03 1485.08 194.457 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.734377, 0, 0, 0.703104, 120.305, -10.3651)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1135.2938,
    y1: 446.4815,
    x2: 1340.3901,
    y2: 446.4815,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#8994B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#5E6E9A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1214.8,269.7c-1,0.6-2.2,0.5-3.2-0.1l-71.9-42.9c-0.3-0.2-0.5-0.4-0.6-0.7h-0.1c-5.4-13.7-4.4-16.4,0-29.7 c0.9-0.5,1.3-0.8,1.3-0.8l3.3,4.5l-0.8,24l70.7,41.5c2.2-1.3,120.9-68.7,120.9-68.7V193l4.8,2.8c1.3,0.8,1.4,2.2-0.1,3 L1214.8,269.7L1214.8,269.7C1214.8,269.6,1214.8,269.7,1214.8,269.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 7074.6997,
    cy: 12753.9307,
    r: 14.4811,
    gradientTransform: "matrix(-1.189303e-02 0.9999 -0.2459 -2.925263e-03 4364.1191 -6826.6284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0019,
    style: {
      stopColor: "#202020",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#222222",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1143.8,199.9l-3.1-1.8c-1.4,6.8-5,24.5,2.2,25.5c0.7-0.4,0,0,0,0L1143.8,199.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1213.5,240.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1143.6,196.5 1143,224 1213.7,265.5 1335.8,196.1 1336.5,168.9 1214.4,238.3 \t\t\t"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 6817.916,
    y1: 10039.624,
    x2: 6817.916,
    y2: 10039.624,
    gradientTransform: "matrix(0.4941 0.8694 -0.8694 0.4941 6573.3955 -10618.8076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#FFC568"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFB248"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1213.7,269.3L1213.7,269.3L1213.7,269.3L1213.7,269.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 6817.916,
    y1: 10039.624,
    x2: 6817.916,
    y2: 10039.624,
    gradientTransform: "matrix(0.4941 0.8694 -0.8694 0.4941 6573.3955 -10618.8076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#FFC568"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFB248"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1213.7,269.3L1213.7,269.3L1213.7,269.3L1213.7,269.3z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1143,225C1143,225,1142.9,225,1143,225c-0.6,0-1-0.5-1-1l0.8-24c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1l-0.8,24 C1144,224.6,1143.5,225,1143,225z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 1139.4783,
    y1: 495.5603,
    x2: 1341.0533,
    y2: 495.5603,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#8994B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#5E6E9A"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1267.1,124.8l73.3,42.4c0.9,0.5,0.9,1.7,0,2.2l-124.6,70.8c-0.8,0.4-1.7,0.4-2.5,0 c-13.2-7.5-73.2-42.5-73.2-42.5c-0.8-0.5-0.8-1.7,0-2.1l124.8-70.9C1265.6,124.3,1266.4,124.4,1267.1,124.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 6802.958,
    y1: 10026.209,
    x2: 6802.958,
    y2: 9893.6182,
    gradientTransform: "matrix(0.4941 0.8694 -0.8694 0.4941 6573.3955 -10618.8076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0081,
    style: {
      stopColor: "#000D1C",
      stopOpacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#000D1C",
      stopOpacity: 0.01
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "1213.7,265.5 1214.4,238.3 1336.5,168.9 1335.8,196.1 \t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 6735.9624,
    y1: 10072.0664,
    x2: 6778.8867,
    y2: 10045.5781,
    gradientTransform: "matrix(0.4941 0.8694 -0.8694 0.4941 6573.3955 -10618.8076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    style: {
      stopColor: "#000D1C",
      stopOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1458,
    style: {
      stopColor: "#000D1C",
      stopOpacity: 0.05279603
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9953,
    style: {
      stopColor: "#000D1C",
      stopOpacity: 0.01
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1143,224 1143.8,199.9 1214.4,238.3 1213.7,265.5 \t\t\t"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -16203.9326,
    y1: -15016.9414,
    x2: -16131.6016,
    y2: -15016.9414,
    gradientTransform: "matrix(-0.4941 -0.8694 0.8694 -0.4941 6265.3398 -21263.5527)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2352,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1214.4,245.3 1214.2,245.2 1142.2,203.7 1142.7,202.9 1214.4,244.2 1254.1,221.6 1254.6,222.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -24864.6465,
    y1: -9944.8564,
    x2: -24769.2637,
    y2: -9944.8564,
    gradientTransform: "matrix(-1.130475e-02 -0.5913 0.5856 -0.6576 6756.9126 -20980.4492)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4972,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "1214.4,249.2 1188.7,234.4 1189.2,233.5 1214.4,248.1 1238.4,234.4 1238.9,235.3 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -24885.4219,
    y1: -9945.9424,
    x2: -24790.2793,
    y2: -9945.9424,
    gradientTransform: "matrix(-1.130475e-02 -0.5913 0.5856 -0.6576 6756.9126 -20980.4492)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2369,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "1214.1,262.2 1188.4,247.4 1188.9,246.6 1214.1,261.1 1237.9,247.5 1238.4,248.4 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -17246.4922,
    y1: -14480.6582,
    x2: -17183.6484,
    y2: -14480.6582,
    gradientTransform: "matrix(-0.3464 -0.7749 0.7705 -0.5565 6415.1826 -21167.6504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "1214.3,259 1172.1,234.1 1172.6,233.3 1214.3,257.9 1269.6,226.4 1270.1,227.3 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 6800.3267,
    y1: 9890.1494,
    x2: 6800.3267,
    y2: 9932.7529,
    gradientTransform: "matrix(0.4941 0.8694 -0.8694 0.4941 6573.3955 -10618.8076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1336.1,179.7 1335.9,179.4 1297.3,201.3 1297.5,201.7 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 6806.499,
    y1: 9893.9473,
    x2: 6806.499,
    y2: 9912.001,
    gradientTransform: "matrix(0.4941 0.8694 -0.8694 0.4941 6573.3955 -10618.8076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "1335.8,187 1335.6,186.6 1319,196.1 1319.2,196.5 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 6811.4507,
    y1: 9896.9424,
    x2: 6811.4507,
    y2: 9923.0977,
    gradientTransform: "matrix(0.4941 0.8694 -0.8694 0.4941 6573.3955 -10618.8076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1335.9,192.7 1335.6,192.3 1311.9,205.8 1312.1,206.2 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 6798.061,
    y1: 9888.624,
    x2: 6798.061,
    y2: 9903.7461,
    gradientTransform: "matrix(0.4941 0.8694 -0.8694 0.4941 6573.3955 -10618.8076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "1336.2,177.1 1336,176.7 1322.1,184.7 1322.3,185 \t\t\t\t"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 6747.6821,
    y1: 10080.5938,
    x2: 6817.0581,
    y2: 10040.2031,
    gradientTransform: "matrix(0.4941 0.8694 -0.8694 0.4941 6573.3955 -10618.8076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    style: {
      stopColor: "#000D1C",
      stopOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1458,
    style: {
      stopColor: "#000D1C",
      stopOpacity: 0.05279603
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9953,
    style: {
      stopColor: "#000D1C",
      stopOpacity: 0.01
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1213.5,268c0,0-0.1,1.7-0.2,2.1c-0.4,0.1-1.1-0.2-2.2-0.8s-70.7-42.3-71.3-42.6c-1.1-0.6,0.4-1.5,0.4-1.5 L1213.5,268z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 6817.6753,
    y1: 10039.4658,
    x2: 6817.6753,
    y2: 9926.1113,
    gradientTransform: "matrix(0.4941 0.8694 -0.8694 0.4941 6573.3955 -10618.8076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0076,
    style: {
      stopColor: "#000D1C",
      stopOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#000D1C",
      stopOpacity: 0.01
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1213.5,268l99.3-56.5v2.4l-98,55.7c0,0-0.7,0.4-1.5,0.4L1213.5,268z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 6843.3447,
    y1: 10236.9268,
    x2: 6807.4678,
    y2: 10230.6514,
    gradientTransform: "matrix(0.5011 0.8654 -0.8654 0.5011 6664.5352 -10882.6309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#FFC568"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFAB48"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1221.7,223.9c-0.8,0.5-1.8,0.4-2.6,0l-58.5-34.3c-0.2-0.1-0.4-0.4-0.5-0.6c0,0,0,0-0.1,0 c-4.5-11.1-4.1-24.5-0.6-35.3c0.7-0.5,1.1-0.6,1.1-0.6l2.7,3.6l-0.1,30.7l57.6,33.2c1.8-1,90.8-52.6,90.8-52.6v-3.1l3.9,2.3 c1.1,0.6,1.2,1.8,0,2.5L1221.7,223.9L1221.7,223.9L1221.7,223.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 7149.7446,
    cy: 12973.4521,
    r: 17.7204,
    gradientTransform: "matrix(-3.882620e-03 1 -0.246 -9.549868e-04 4382.7021 -6967.0068)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0019,
    style: {
      stopColor: "#202020",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#222222",
      stopOpacity: 0
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1163.3,156.6l-2.5-1.4c-1.1,5.5-3.5,31.1,2.4,31.9c0.6-0.3,0,0,0,0L1163.3,156.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1220,189"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1163.1,153.8 1163.1,187.3 1220.7,220.5 1312.5,167.4 1312.4,134.1 1220.7,187.2 \t\t\t"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 6883.2603,
    y1: 10276.2402,
    x2: 6883.2603,
    y2: 10276.2402,
    gradientTransform: "matrix(0.5011 0.8654 -0.8654 0.5011 6664.5352 -10882.6309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#FFC568"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFB248"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1220.7,223.6L1220.7,223.6L1220.7,223.6L1220.7,223.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 6883.2603,
    y1: 10276.2402,
    x2: 6883.2603,
    y2: 10276.2402,
    gradientTransform: "matrix(0.5011 0.8654 -0.8654 0.5011 6664.5352 -10882.6309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#FFC568"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFB248"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1220.7,223.6L1220.7,223.6L1220.7,223.6L1220.7,223.6z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1163.1,188.3L1163.1,188.3c-0.6,0-1-0.5-1-1l0.1-30.7c0-0.6,0.4-1,1-1l0,0c0.6,0,1,0.5,1,1l-0.1,30.7 C1164.1,187.9,1163.7,188.3,1163.1,188.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 6828.2993,
    y1: 10220.6719,
    x2: 6791.2383,
    y2: 10225.4082,
    gradientTransform: "matrix(0.5011 0.8654 -0.8654 0.5011 6664.5352 -10882.6309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#FFC568"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFAB48"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1255.9,98.8l59.7,33.9c0.7,0.4,0.7,1.4,0,1.8l-93.8,54.3c-0.6,0.4-1.4,0.4-2,0c-10.8-6-59.6-33.9-59.6-33.9 c-0.7-0.4-0.7-1.3,0-1.7l93.9-54.4C1254.7,98.5,1255.4,98.5,1255.9,98.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 6866.1919,
    y1: 10265.3105,
    x2: 6866.1919,
    y2: 10160.0283,
    gradientTransform: "matrix(0.5011 0.8654 -0.8654 0.5011 6664.5352 -10882.6309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0081,
    style: {
      stopColor: "#000D1C",
      stopOpacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#000D1C",
      stopOpacity: 0.01
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "1220.7,220.5 1220.7,187.2 1312.4,134.1 1312.5,167.4 \t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 6810.3779,
    y1: 10300.7715,
    x2: 6847.7939,
    y2: 10277.6826,
    gradientTransform: "matrix(0.5011 0.8654 -0.8654 0.5011 6664.5352 -10882.6309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    style: {
      stopColor: "#000D1C",
      stopOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1458,
    style: {
      stopColor: "#000D1C",
      stopOpacity: 0.05279603
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9953,
    style: {
      stopColor: "#000D1C",
      stopOpacity: 0.01
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "1163.1,187.3 1163.3,156.6 1220.7,187.2 1220.7,220.5 \t\t\t"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: -16263.9121,
    y1: -15251.5371,
    x2: -16205.0859,
    y2: -15251.5371,
    gradientTransform: "matrix(-0.5011 -0.8654 0.8654 -0.5011 6271.3081 -21524.5254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2352,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "1220.8,193 1161.9,159.8 1162.4,158.9 1220.8,191.9 1252.7,173.4 1253.2,174.3 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: -24814.1855,
    y1: -10240.1582,
    x2: -24736.7539,
    y2: -10240.1582,
    gradientTransform: "matrix(-1.604132e-02 -0.5912 0.5803 -0.6623 6765.0967 -21245.3633)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4972,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "1220.8,196.2 1199.8,184.3 1200.3,183.5 1220.8,195 1240.1,183.9 1240.6,184.7 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: -24835.6055,
    y1: -10241.6152,
    x2: -24758.2305,
    y2: -10241.6152,
    gradientTransform: "matrix(-1.604132e-02 -0.5912 0.5803 -0.6623 6765.0967 -21245.3633)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2369,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "1220.3,209.8 1199.4,198 1199.9,197.1 1220.3,208.7 1239.5,197.6 1240,198.4 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: -17286.2988,
    y1: -14727.9678,
    x2: -17235.1582,
    y2: -14727.9678,
    gradientTransform: "matrix(-0.3526 -0.7721 0.766 -0.5627 6421.8823 -21429.8203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "1220.7,206.9 1186.3,186.9 1186.8,186.1 1220.7,205.7 1265.3,179.9 1265.8,180.8 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: -17295.0703,
    y1: -14734.0566,
    x2: -17230.627,
    y2: -14734.0566,
    gradientTransform: "matrix(-0.3526 -0.7721 0.766 -0.5627 6421.8823 -21429.8203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "1220.6,215.6 1220.4,215.4 1175.8,190 1176.3,189.1 1220.6,214.4 1268,187 1268.5,187.9 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 6858.6597,
    y1: 10156.7324,
    x2: 6858.6597,
    y2: 10191.2578,
    gradientTransform: "matrix(0.5011 0.8654 -0.8654 0.5011 6664.5352 -10882.6309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "1312.5,142.2 1312.4,141.9 1281.3,159.9 1281.4,160.2 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 6864.1328,
    y1: 10159.8701,
    x2: 6864.1328,
    y2: 10174.501,
    gradientTransform: "matrix(0.5011 0.8654 -0.8654 0.5011 6664.5352 -10882.6309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "1312.5,148.5 1312.4,148.2 1299,156 1299.1,156.3 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 6873.9038,
    y1: 10165.2578,
    x2: 6873.9038,
    y2: 10208.9541,
    gradientTransform: "matrix(0.5011 0.8654 -0.8654 0.5011 6664.5352 -10882.6309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "1312.6,159.8 1312.4,159.5 1274,181.7 1274.1,182 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 6876.5991,
    y1: 10166.8564,
    x2: 6876.5991,
    y2: 10180.2412,
    gradientTransform: "matrix(0.5011 0.8654 -0.8654 0.5011 6664.5352 -10882.6309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "1312.6,162.9 1312.4,162.6 1300.3,169.6 1300.5,169.9 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 6866.981,
    y1: 10161.7061,
    x2: 6866.981,
    y2: 10182.9014,
    gradientTransform: "matrix(0.5011 0.8654 -0.8654 0.5011 6664.5352 -10882.6309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "1312.5,151.8 1312.4,151.5 1293.2,162.6 1293.4,162.9 \t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 6855.0098,
    y1: 10154.542,
    x2: 6855.0098,
    y2: 10166.7969,
    gradientTransform: "matrix(0.5011 0.8654 -0.8654 0.5011 6664.5352 -10882.6309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#EFEFEF",
      stopOpacity: 0
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "1312.5,138 1312.3,137.7 1301.1,144.2 1301.3,144.5 \t\t\t\t"
  })))))), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.734377, 0, 0, 0.703104, 120.305, -10.3651)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "853.5,203.8 870.1,194.3 919.2,222.9 920.7,223.6 920.5,235 901.2,232.3 \t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 3042.4265,
    y1: -811.3428,
    x2: 3089.2712,
    y2: -811.3428,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -489.0637 390.536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "883.4,206.4 866.9,196.7 867,196.4 883.6,206 \t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 3024.8169,
    y1: -811.2462,
    x2: 3071.6616,
    y2: -811.2462,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -489.0637 390.536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "874.2,211.2 857.8,201.5 858,201.2 874.5,210.9 \t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 1167.5752,
    y1: 308.3731,
    x2: 1202.7096,
    y2: 308.3731,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -157.3632 595.1664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "889.4,215 861.8,199.1 862,198.8 889.5,214.7 \t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 1160.8577,
    y1: 299.0565,
    x2: 1217.1444,
    y2: 299.0565,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -157.3632 595.1664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "899.9,228.4 855.8,202.7 856,202.4 900.1,228.1 \t\t\t"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M919.2,222.9c-2.5,2.9-9.6,7.2-16.7,8.5c4,5.3,4.4,5.5,4.4,5.5l13.3-10.9v-3.4L919.2,222.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 921.1498,
    y1: 455.7514,
    x2: 921.1498,
    y2: 455.7514,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M921.1,222.2L921.1,222.2L921.1,222.2L921.1,222.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 921.1498,
    y1: 455.7514,
    x2: 921.1498,
    y2: 455.7514,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M921.1,222.2L921.1,222.2L921.1,222.2L921.1,222.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 900.0527,
    y1: 424.1278,
    x2: 920.9017,
    y2: 424.3191,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M921.1,222.2L921.1,222.2v83.5c0,1.4,0,2.6-0.5,3.8c-1.1,2.7-7.7,6.8-12.7,7.2c-1.8,0.2-3.7-0.2-4.6-0.6 c-0.4-0.2-0.5-1.1-1.5-0.9l-1.9-1.1v-83.6c9.1,4.5,21.2-4.5,19.1-7.7l-49.1-28.5l-1.8,1l0.2-3.3c0-0.6,0.7-1.1,1.2-0.7l50.3,29.1 C920.8,220.8,921.1,221.5,921.1,222.2L921.1,222.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 850.3698,
    y1: 419.9507,
    x2: 900.0631,
    y2: 419.9507,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0057,
    style: {
      stopColor: "#1F6FDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C8CE4"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M851.1,285.4l48.9,28.6v-83.6c-7.9-3.9-48.5-28.3-48.5-28.3c-0.5-0.3-1.2,0.1-1.2,0.7v81.2 C850.4,284.7,850.7,285.2,851.1,285.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "825.7,208.8 842.5,199.6 891.5,227.9 892.9,228.7 892.7,240.1 873.5,237.3 \t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 2981.019,
    y1: -796.6178,
    x2: 3027.8645,
    y2: -796.6178,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -489.0637 390.536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "855.6,211.4 839.1,201.7 839.4,201.4 855.8,211.1 \t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 2963.4094,
    y1: -796.5212,
    x2: 3010.2549,
    y2: -796.5212,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -489.0637 390.536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "846.6,216.3 830.1,206.6 830.2,206.3 846.7,216 \t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 1135.0417,
    y1: 305.8972,
    x2: 1170.2054,
    y2: 305.8972,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -157.3632 595.1664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "861.6,219.9 834.1,204.2 834.2,203.9 861.8,219.6 \t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 1128.3188,
    y1: 296.5352,
    x2: 1184.5861,
    y2: 296.5352,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -157.3632 595.1664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "872.2,233.4 828.1,207.8 828.3,207.4 872.4,233.1 \t\t\t"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M891.5,227.9c-2.5,2.9-9.6,7.2-16.7,8.5c4,5.3,4.4,5.5,4.4,5.5l13.3-10.9v-3.4L891.5,227.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 893.4735,
    y1: 450.7898,
    x2: 893.4735,
    y2: 450.7898,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M893.5,227.2L893.5,227.2L893.5,227.2L893.5,227.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 893.4735,
    y1: 450.7898,
    x2: 893.4735,
    y2: 450.7898,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M893.5,227.2L893.5,227.2L893.5,227.2L893.5,227.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 872.4402,
    y1: 414.6704,
    x2: 893.2007,
    y2: 414.8608,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#FE7E66"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9939,
    style: {
      stopColor: "#F9674B"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M893.5,227.3L893.5,227.3v92.3c0,1.4,0,2.6-0.5,3.8c-1.1,2.7-7.7,6.8-12.7,7.2c-1.8,0.2-3.7-0.2-4.6-0.6 c-0.4-0.2-0.5-1.1-1.5-0.9l-1.9-1.1v-92.4c9.1,4.5,21.2-4.5,19.1-7.7l-48.9-28.3l-1.7,0.9v-3.5c0-0.6,0.7-1.1,1.2-0.7l50.3,29.1 C893,225.8,893.5,226.5,893.5,227.3C893.5,227.2,893.5,227.2,893.5,227.3z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M823.4,299.3l48.9,28.6v-92.4c-7.9-3.9-48.5-28.3-48.5-28.3c-0.5-0.3-1.2,0.1-1.2,0.7v90.2 C822.6,298.6,822.9,299.1,823.4,299.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_52_",
    transform: "matrix(0.6541 -0.7564 0.7564 0.6541 165.0287 674.9475)",
    cx: 820.5,
    cy: 157,
    rx: 115.1,
    ry: 101.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_53_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6541, -0.7564, 0.7564, 0.6541, 165.029, 674.948)",
    cx: 820.5,
    cy: 157,
    rx: 115.1,
    ry: 101.2,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st56"
  }, /*#__PURE__*/React.createElement("g", null, _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "841.6,127.3 879.5,105.7 991.2,170.7 994.6,172.5 994,198.4 950.3,192.2 \t\t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 2986.4749,
    y1: -707.0982,
    x2: 3093.064,
    y2: -707.0982,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -489.0637 390.536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "909.7,133.2 872.2,111.1 872.5,110.4 910.1,132.5 \t\t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 2946.407,
    y1: -706.8036,
    x2: 3053.0056,
    y2: -706.8036,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -489.0637 390.536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "889,144.2 851.4,122.2 851.8,121.5 889.4,143.5 \t\t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 1155.3933,
    y1: 384.278,
    x2: 1235.3903,
    y2: 384.278,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -157.3632 595.1664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "923.3,152.6 860.7,116.7 861.1,116 923.7,151.9 \t\t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 1140.1244,
    y1: 363.0516,
    x2: 1268.2134,
    y2: 363.0516,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -157.3632 595.1664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "947.4,183.2 847,124.9 847.4,124.2 947.7,182.5 \t\t\t\t\t"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M991.2,170.7c-5.6,6.7-21.9,16.5-38.1,19.5c9.1,12.1,10,12.5,10,12.5l30.4-24.9v-7.8L991.2,170.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 995.6511,
    y1: 508.7783,
    x2: 995.6511,
    y2: 508.7783,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M995.7,169.2L995.7,169.2L995.7,169.2L995.7,169.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 995.6511,
    y1: 508.7783,
    x2: 995.6511,
    y2: 508.7783,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M995.7,169.2L995.7,169.2L995.7,169.2L995.7,169.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 875.4879,
    y1: 436.553,
    x2: 995.6511,
    y2: 436.553,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M995.7,169.2L995.7,169.2v189.9c0,3.1-0.1,6-1.1,8.7c-2.5,6.3-17.5,15.5-28.8,16.4 c-4,0.3-8.5-0.5-10.4-1.5c-0.9-0.5-1.1-2.5-3.4-2.1l-4.3-2.4V188.1c20.6,10.2,48.1-10.3,43.6-17.4l-111.6-65l-4.1,2.3l0.5-7.5 c0-1.5,1.6-2.4,2.9-1.6l114.4,66.2C994.7,166,995.7,167.5,995.7,169.2L995.7,169.2z"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M836.3,313.1l111.3,65.1V188.1c-18.1-8.9-110.2-64.4-110.2-64.4c-1.2-0.7-2.7,0.2-2.7,1.6v184.9 C834.6,311.4,835.3,312.5,836.3,313.1z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_61_",
    transform: "matrix(0.6541 -0.7564 0.7564 0.6541 165.0287 674.9475)",
    cx: 820.5,
    cy: 157,
    rx: 115.1,
    ry: 101.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_62_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6541, -0.7564, 0.7564, 0.6541, 165.029, 674.948)",
    cx: 820.5,
    cy: 157,
    rx: 115.1,
    ry: 101.2,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st65"
  }, /*#__PURE__*/React.createElement("g", null, _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "778.5,138.8 816.7,117.7 928,182.2 931.4,184 930.9,209.8 887.2,203.6 \t\t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 2846.752,
    y1: -673.5137,
    x2: 2953.3506,
    y2: -673.5137,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -489.0637 390.536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "846.6,144.6 809,122.6 809.4,121.9 847,143.9 \t\t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 2806.6841,
    y1: -673.1573,
    x2: 2913.3445,
    y2: -673.1573,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -489.0637 390.536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "825.8,155.7 788.3,133.6 788.7,132.9 826.3,155 \t\t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 1081.3875,
    y1: 378.5826,
    x2: 1161.467,
    y2: 378.5826,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -157.3632 595.1664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "860.1,164 797.5,128.2 798,127.5 860.6,163.3 \t\t\t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 1066.1166,
    y1: 357.3562,
    x2: 1194.2157,
    y2: 357.3562,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -157.3632 595.1664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "884.2,194.6 783.9,136.3 784.2,135.6 884.6,194 \t\t\t\t\t"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M928,182.2c-5.6,6.7-21.9,16.5-38.1,19.5c9.1,12.1,10,12.5,10,12.5l30.3-24.9v-7.8L928,182.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 932.546,
    y1: 497.3821,
    x2: 932.546,
    y2: 497.3821,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M932.5,180.6L932.5,180.6L932.5,180.6L932.5,180.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 932.546,
    y1: 497.3821,
    x2: 932.546,
    y2: 497.3821,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M932.5,180.6L932.5,180.6L932.5,180.6L932.5,180.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 884.7642,
    y1: 415.2487,
    x2: 932.0018,
    y2: 415.682,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#FE7E66"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9939,
    style: {
      stopColor: "#F9674B"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M932.5,180.7L932.5,180.7v210c0,3.1-0.1,6-1.1,8.7c-2.5,6.3-17.5,15.5-28.8,16.4c-4,0.3-8.5-0.5-10.4-1.5 c-0.9-0.5-1.1-2.5-3.4-2.1l-4.3-2.4V199.5c20.6,10.2,48.1-10.3,43.6-17.4l-111.4-64.3l-4,2.2V112c0-1.5,1.6-2.4,2.9-1.6 l114.4,66.2C931.6,177.4,932.5,178.9,932.5,180.7C932.5,180.6,932.5,180.6,932.5,180.7z"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M773.2,344.7l111.3,65.1V199.5c-18.1-8.9-110.2-64.4-110.2-64.4c-1.2-0.7-2.7,0.2-2.7,1.6v205.1 C771.4,343,772.1,344.1,773.2,344.7z"
  }))))), /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6541 -0.7564 0.7564 0.6541 171.2633 674.8179)",
    className: "st73",
    cx: 823.5,
    cy: 150.1,
    rx: 115.1,
    ry: 101.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M738.3,231.4c0,0-105.2,108.5-114.3,116.7c-17.3,15.5,3.8,37.1,19.5,23.5c13.4-11.7,116.8-123,116.8-123 L738.3,231.4z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M936.4,77.5C898,26.8,819.7,21.4,761.5,65.4c-58.1,44-74.2,120.9-35.7,171.6 c38.5,50.7,116.8,56.1,174.9,12.1C958.8,205.1,974.8,128.3,936.4,77.5z M886.4,230.3c-47.5,36-111.6,31.6-143-9.9 s-18.3-104.3,29.2-140.2c47.5-36,111.5-31.6,142.9,9.9S933.9,194.3,886.4,230.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_70_",
    cx: 823.4903,
    cy: 529.7875,
    r: 123.9596,
    gradientTransform: "matrix(1 0 0 -1 0 678)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0033,
    style: {
      stopColor: "#C9CEDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#B6BDD1"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M928.8,68.4c-38.5-50.7-116.8-56.1-174.9-12.1c-58.1,44-74.2,120.9-35.7,171.6 c38.5,50.7,116.8,56.1,174.9,12.1S967.2,119.2,928.8,68.4z M878.7,221.2c-47.5,36-111.5,31.6-142.9-9.9S717.6,107,765.1,71.1 c47.5-36,111.5-31.6,142.9,9.9C939.4,122.5,926.3,185.2,878.7,221.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_71_",
    cx: 683.5552,
    cy: 382.8089,
    r: 71.8144,
    gradientTransform: "matrix(1 0 0 -1 0 678)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0033,
    style: {
      stopColor: "#C9CEDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#B6BDD1"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M733,222.9c0,0-105.2,108.5-114.3,116.7c-17.3,15.5,3.8,37.1,19.5,23.5c13.4-11.7,116.8-123,116.8-123 L733,222.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.734377, 0, 0, 0.703104, 120.305, -10.3651)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "319.9,96.6 296.5,83.3 227.5,123.4 225.4,124.6 225.7,140.6 252.7,136.7 \t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 11500.5771,
    y1: -3548.9944,
    x2: 11566.4443,
    y2: -3548.9944,
    gradientTransform: "matrix(-0.5197 -0.2824 -0.2824 -0.834 5281.3027 390.536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "277.8,100.2 301.1,86.6 300.8,86.2 277.6,99.8 \t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 11475.8164,
    y1: -3548.7998,
    x2: 11541.6846,
    y2: -3548.7998,
    gradientTransform: "matrix(-0.5197 -0.2824 -0.2824 -0.834 5281.3027 390.536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "290.7,107.1 313.9,93.4 313.6,93 290.4,106.6 \t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 5486.6245,
    y1: 46.1602,
    x2: 5536.0674,
    y2: 46.1602,
    gradientTransform: "matrix(-0.8448 -8.174699e-02 -0.1031 -0.9449 4949.6021 595.1664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "269.4,112.3 308.1,90.1 307.9,89.7 269.2,111.8 \t\t\t"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 5477.1714,
    y1: 33.1007,
    x2: 5556.3506,
    y2: 33.1007,
    gradientTransform: "matrix(-0.8448 -8.174699e-02 -0.1031 -0.9449 4949.6021 595.1664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "254.6,131.1 316.6,95.1 316.3,94.7 254.3,130.7 \t\t\t"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M227.5,123.4c3.5,4.2,13.5,10.2,23.5,12c-5.6,7.5-6.2,7.7-6.2,7.7l-18.7-15.4v-4.8L227.5,123.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 4567.5205,
    y1: 555.5046,
    x2: 4567.5205,
    y2: 555.5046,
    gradientTransform: "matrix(-1 0 0 -1 4792.2393 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M224.7,122.5L224.7,122.5L224.7,122.5L224.7,122.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 4567.5205,
    y1: 555.5046,
    x2: 4567.5205,
    y2: 555.5046,
    gradientTransform: "matrix(-1 0 0 -1 4792.2393 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M224.7,122.5L224.7,122.5L224.7,122.5L224.7,122.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 4537.7969,
    y1: 511.0236,
    x2: 4567.1118,
    y2: 511.2924,
    gradientTransform: "matrix(-1 0 0 -1 4792.2393 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M224.7,122.5L224.7,122.5v117.3c0,1.9,0,3.7,0.7,5.3c1.6,3.9,10.8,9.6,17.8,10.2c2.5,0.2,5.3-0.3,6.4-0.9 c0.6-0.3,0.7-1.5,2.1-1.3l2.7-1.6V134.2c-12.7,6.3-29.7-6.4-27-10.8l69-40.1l2.5,1.5l-0.3-4.7c0-0.9-1-1.5-1.8-1L226.1,120 C225.3,120.5,224.7,121.4,224.7,122.5L224.7,122.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 4468.0054,
    y1: 504.747,
    x2: 4539.1558,
    y2: 504.747,
    gradientTransform: "matrix(-1 0 0 -1 4792.2393 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0057,
    style: {
      stopColor: "#1F6FDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C8CE4"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M323.2,211.4l-70.1,40.9V134.8c11.2-5.5,69.4-40.4,69.4-40.4c0.8-0.4,1.7,0.1,1.7,1v114.3 C324.3,210.4,323.9,211.1,323.2,211.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "376.3,171.7 467,223.7 467,341 376.3,289 \t\t"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M467.6,342.1l-92-52.7V170.6l92,52.7V342.1z M376.9,288.6l89.5,51.3V224.1l-89.5-51.3V288.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "429,296.4 391,274.6 391,269.8 429,291.6 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "444.6,282.5 391,252 391,247.2 444.6,277.7 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "438.7,267.3 391,239.9 391,235.1 438.7,262.4 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "420.3,232.6 391,215.8 391,211 420.3,227.8 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "429,225.6 391,203.8 391,199 429,220.8 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "420.3,280.1 391,263.2 391,258.4 420.3,275.3 \t\t"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 333.8,
    y: 157.9,
    transform: "matrix(0.5082 -0.8612 0.8612 0.5082 -11.8175 388.5208)",
    className: "st86",
    width: 1,
    height: 93.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M290.5,182.9c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5s4.5,2,4.5,4.5S293,182.9,290.5,182.9z M290.5,174.9 c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5S292.4,174.9,290.5,174.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.734377, 0, 0, 0.703104, 120.305, -10.3651)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "1461.2,186.3 1534.8,143.6 1617.5,191.4 1543.8,234.1 \t\t"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M1618.4,191.4l-74.6,43.3l-83.6-48.3l74.6-43.3L1618.4,191.4z M1543.8,233.5l72.6-42.1l-81.6-47.1 l-72.6,42.1L1543.8,233.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "1556.7,208.1 1539.7,217.9 1536.3,216 1553.3,206.1 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "1567.1,183.3 1523.7,208.6 1520.4,206.7 1563.8,181.4 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "1553.9,181.3 1515.3,203.8 1511.8,201.8 1550.6,179.4 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "1539.2,170.3 1498.3,194 1494.9,192 1535.8,168.4 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "1520.6,171.1 1489.8,189 1486.5,187.1 1517.3,169.2 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "1576.7,187.2 1531.7,213.3 1528.3,211.3 1573.4,185.3 \t\t"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1615.8,
    y: 192.5,
    transform: "matrix(0.518 -0.8554 0.8554 0.518 581.7893 1493.5741)",
    className: "st86",
    width: 0.8,
    height: 76.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1872.1,253.1c0.3-0.2,0.4-0.5,0.5-0.9c0-0.3,0-1-0.1-1.6c0-0.4-0.5-0.8-1.1-1.1 c-3.3-1.9-110.1-63.6-112.2-64.8c-1-0.6-1.7-0.8-2.4-0.4c-1.2,0.7-30.4,17.5-62.7,36.1c-3.3,2-4.4,5.9-7.8,7.8 c-2.4,1.4-7.2,0.9-9.7,2.3c-34.8,20.1-72.4,41.6-73.9,42.5c-0.4,0.2-0.4,0.5-0.4,1c0,0.4,0,0.7,0,1c0,0.7,0.1,1,0.7,1.3 c1.7,1,110.3,63.6,112.8,65.1c1.3,0.7,1.8,0.8,3.1,0.1C1722,339.5,1872.1,253.1,1872.1,253.1z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1787.9,301.6c0.2-0.1,0.6,0.2,0.8,0.2c1.5,0.2,5.7-1.4,10.1-3.9c4.6-2.6,8.1-5.5,8.5-6.9 c0.1-0.2,0.3-0.7,0.5-0.8c1.1-0.6-5.9,0.8-11.2,3.8C1791.3,297,1787.4,302,1787.9,301.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: -18562.7422,
    y1: 370.9047,
    x2: -18561.7715,
    y2: 369.2348,
    gradientTransform: "matrix(-1 0 0 -1 -16902.4688 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#FFC568"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFAB48"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M1717.5,341.9c-0.6,0.1-1-0.2-1.7-0.6c-2.4-1.4-111.1-64.1-112.8-65.1c-0.6-0.3-0.7-0.6-0.7-1.3 c0-0.3,0-0.6,0-1c0-0.2,0-0.4,0.1-0.6l115.1,66.4V341.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_81_",
    cx: -18821.3145,
    cy: 2012.7902,
    r: 16.9212,
    gradientTransform: "matrix(-0.8716 0.4902 -0.1031 -0.1833 -14402.1533 9887.7539)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    style: {
      stopColor: "#FFAB48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#FFC568"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M1783.2,299.8c0.2-0.1,3,0.5,3.3,0.6c1.7,0.2,6.1-1.5,10.9-4.2c4.9-2.8,8.6-5.9,9.1-7.5 c0.1-0.2,0.2-2.5,0.4-2.6c1.1-0.7-6.3,2.5-12,5.9C1789.3,295.2,1782.6,300.1,1783.2,299.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: -18696.8574,
    y1: 383.0002,
    x2: -18696.1035,
    y2: 384.293,
    gradientTransform: "matrix(-1 0 0 -1 -16902.4688 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    style: {
      stopColor: "#FFAB48",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFAB48"
    }
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "1719.3,336.3 1866.9,251.4 1868.7,252.3 1721.5,337.1 \t\t\t"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1866.9,251.2 1719.6,336.6 1608.4,272.8 1756.9,186.4 \t\t\t"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1608.4,272.8l2-7.4c28-14.9,36.5-32.6,52.2-39.8c11.3-5.1,20.2-1.1,23.1,2.4h0.1 c0.1-3.5,4.3-17.3,21.8-26.2c15.1-7.7,24.7-3.7,46.2-17.4l111.1,63.8l1.9,3.1l-147.3,85.4L1608.4,272.8L1608.4,272.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: -18628.6094,
    y1: 425.7519,
    x2: -18613.7578,
    y2: 401.9464,
    gradientTransform: "matrix(-1 0 0 -1 -16902.4688 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5F5F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#F5F5F7",
      stopOpacity: 0
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M1662.6,225.6c8.5-3.8,15.5-2.5,19.9-0.2l0.7,0.3c1.1,0.7,2.6,1.5,2.8,1.6l106.4,61.6l-14.6,6.7 c0,0-16.3,9.5-17.3,9.4c-0.9-0.2-91.7-53.9-114.2-67.4C1651.6,232.6,1656.6,228.3,1662.6,225.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: -18650.5977,
    y1: 414.4368,
    x2: -18669.2715,
    y2: 444.0287,
    gradientTransform: "matrix(-1 0 0 -1 -16902.4688 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2411,
    style: {
      stopColor: "#F5F5F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#F5F5F7",
      stopOpacity: 0
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M1707.1,201.6c1.2-0.7,2.4-1.1,3.4-1.6l120.2,71.8l-38.5,22.3l-0.3-5.3l-106.4-61.6 C1685.9,223.2,1690.5,210.2,1707.1,201.6z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M1866.9,251.2c0,0-67.5,39.1-70.4,40.8c0-3.3,4.5-17.5,22.1-26.4c15.1-7.7,25.8-4.1,46.5-17.4L1866.9,251.2 z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M1796.5,292c-2.8-3.4-11.8-7.6-23.2-2.4c-15.7,7.1-23.7,24.7-51.8,39.5l-2,7.4l75.5-43.8L1796.5,292z"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "1610.4,265.4 1608.4,272.8 1719.6,336.6 1721.5,329.1 \t\t\t"
  }))))), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: "37.1px",
      textTransform: "capitalize",
      whiteSpace: "pre"
    },
    x: 1309.33,
    y: 34.369,
    transform: "matrix(1.12006, 0, 0, 1.07236, -335.05, -10.8855)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditeursprosCover);
export default __webpack_public_path__ + "static/media/editeurspros_cover.bce8174e5323c0a5c2568ce10e911e36.svg";
export { ForwardRef as ReactComponent };